import { Component, Input, TemplateRef, ChangeDetectionStrategy } from "@angular/core";
import { ISearchResponseRow, ISearchResultRenderer } from "../../quick-search.models";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "rask-produktinstruktion-renderer",
    templateUrl: "./produktinstruktion-renderer.component.html",
    styleUrls: [
        "./produktinstruktion-renderer.component.scss",
        "../default-renderer.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgbPopover]
})
export class ProduktinstruktionRendererComponent implements ISearchResultRenderer {
    @Input() input: ISearchResponseRow;
    @Input() tooltipTemplate: TemplateRef<any>;
}
